import { render, staticRenderFns } from "./checkAgreement.vue?vue&type=template&id=cb948db4&"
import script from "./checkAgreement.vue?vue&type=script&lang=js&"
export * from "./checkAgreement.vue?vue&type=script&lang=js&"
import style0 from "./checkAgreement.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports